import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1713797a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-history-list-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "report-history-list",
  role: "list",
  "aria-label": "신고 내역 목록"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.reportHistories.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.reportHistories, (history, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              role: "listitem"
            }, [
              _createVNode($setup["ReportHistoryRow"], { reportHistory: history }, null, 8 /* PROPS */, ["reportHistory"])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : (_openBlock(), _createBlock($setup["EmptyContent"], {
          key: 1,
          class: "empty-content",
          text: "신고 내역이 없습니다"
        }))
  ]))
}